import { IResidentialComplex } from '../types/residentials';

export function checkPikPlusResidentialComplexes(complexes: IResidentialComplex[]): boolean {
  return complexes.some(item => item.displayType === 'plus');
}
